import React, { useEffect, useState } from 'react'
import { Card, Col, Container, Row, Button } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import AddCenterUserForm from '../components/form/AddCenterUserForm'

const AddCenterUser = () => {
    const {id}= useParams();
    const [isEdit, setIsEdit] = useState(false);
    useEffect(()=>{
        if(id){
            setIsEdit(true);
        }
    },[id]);

  return (
    <>
   <Container> 
    <Row className='justify-content-center'>
        <Col md={10}>
            <Card className=' shadow-sm px-5 pt-5 pb-3 ' border='0'>
                <Row>
                    <Col>
                        <h2 className='text-secondary'>{isEdit ? 'Edit':'Add'} Center User</h2>
                    </Col>
                </Row>
                <Row className='mt-4'>
                    <Col>
                        <AddCenterUserForm />
                    </Col>
                </Row>
            </Card>  
        </Col>
    </Row>
    </Container>
   </>
  )
}

export default AddCenterUser
